<template>
  <md-button v-on="$listeners" v-bind="$attrs" :class="classes">
    <gl-icon v-if="iconPre" :icon="iconPre" />
    <span class="text">
      <slot></slot>
    </span>
    <gl-icon v-if="iconPost" :icon="iconPost" />
  </md-button>
</template>

<script>
/**
 * アプリケーション共通で使用するボタンコンポーネント
 *
 * Material Designのボタンです。
 */
export default {
  props: {
    iconButton: {
      type: Boolean,
      default: false,
    },
    raised: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    accent: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    /**
     * ボタンテキストの前に表示するアイコン
     */
    iconPre: {
      type: String,
    },
    /**
     * ボタンテキストの後ろに表示するアイコン
     */
    iconPost: {
      type: String,
    },
  },
  computed: {
    classes() {
      return {
        'md-icon-button': this.iconButton,
        'md-raised': this.raised,
        'md-primary': this.primary,
        'md-accent': this.accent,
        'md-fab': this.fab,
        'md-plain': this.plain,
        'md-dense': this.dense,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$icon-margin: 5px;

.text {
  &:not(:first-child) {
    margin-left: $icon-margin;
  }
  &:not(:last-child) {
    margin-right: $icon-margin;
  }
}

.gl-icon {
  height: 16px;
}
</style>
